import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';
import { MotorsPackageTypeEnum } from '@classifieds-sell/datalayer';
import { ActivatedRoute } from '@angular/router';
import { getSummarySectionLinkText } from '../../../helpers/summary-page.helper';

@Component({
    selector: 'motors-summary-page-vehicle-description-section',
    templateUrl: './summary-page-vehicle-description-section.component.html',
    styleUrls: ['./summary-page-vehicle-description-section.component.scss']
})
export class SummaryPageVehicleDescriptionSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    title: string;
    subTitle: string;
    description: string;
    summarySectionLinkText: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: MotorsDraftFacade,
        private route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            const subTitleDisabled = this.draftData.listingDetails.categoryPackageId !== MotorsPackageTypeEnum.PREMIUM;

            this.title = this.draftData.descriptionAndPhotos.listingTitle;
            this.subTitle = subTitleDisabled ? '' : this.draftData.descriptionAndPhotos.subTitle;
            this.description = this.draftData.descriptionAndPhotos.description;
            this.summarySectionLinkText = getSummarySectionLinkText(this.route);
            this._changeDetectorRef.markForCheck();
           });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
